module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "vog.b29f88a7.jpg";